import { useEffect, useState } from 'react';
import { Button, Space } from 'antd';
import PropTypes from 'prop-types';
import EbzModal from 'components/EbzModal';
import EbzTable from 'components/EbzTable';
import reportsAPI from 'services/reports';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';
import InvoiceSummaryModal from './InvoiceSummaryModal';

function BulkInvoiceModal(props) {
  const {
    invoiceData,
    setSelectedInvoice,
    selectedInvoice,
    invoiceSummaryModal,
    toggleInvoiceSummary,
    columns,
    bulkInvoiceModal,
    payoutAcceptInvoice,
    width,
    toggleModal,
    loading
  } = props;
  const [invoiceSummaryLoading, setInvoiceSummaryLoading] = useState(false);
  const [invoiceSummary, setInvoiceSummary] = useState([]);

  const handleDrawerClose = () => {
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: 'Close' });
    toggleModal();
    toggleInvoiceSummary();
  };
  const fetchInvoiceSummary = async () => {
    setInvoiceSummaryLoading(true);
    const response = await reportsAPI.bulkInvoiceSummary({
      partner_payout_id: [...selectedInvoice]
    });

    if (!response.success) {
      console.log('something went wrong');
      // setInvoiceSummaryLoading(false);
      // return;
    }
    setInvoiceSummary(response?.data ?? []);
    setInvoiceSummaryLoading(false);
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedInvoice(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      name: record.name
    })
  };
  useEffect(() => {
    if (invoiceSummaryModal) fetchInvoiceSummary();
  }, [invoiceSummaryModal]);

  return (
    <EbzModal
      title=""
      toggleModal={toggleModal}
      onClose={handleDrawerClose}
      width={width}
      isOpen={bulkInvoiceModal || invoiceSummaryModal}
    >
      <Space direction="vertical" align="end" style={{ width: '100%' }}>
        {!invoiceSummaryModal && (
          <>
            <div style={{ width: '100%', overflow: 'auto' }}>
              <EbzTable
                columns={columns}
                rowSelection={rowSelection}
                // eslint-disable-next-line no-underscore-dangle
                rowKey={(r) => `${r._id}`}
                dataSource={invoiceData ?? []}
                loading={loading}
                pagination={false}
                isPagination={false}
                scroll={{ y: 440, scrollToFirstRowOnChange: true }}
                size="medium"
                style={{ width: '100%' }}
              />
            </div>

            <Button
              type="primary"
              size="medium"
              disabled={!selectedInvoice?.length}
              onClick={() => {
                trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                  name: 'Bulk Upload Next Button'
                });
                toggleInvoiceSummary();
              }}
            >
              Next
            </Button>
          </>
        )}
      </Space>
      <Space direction="vertical" style={{ width: '100%' }}>
        {invoiceSummaryModal && (
          <InvoiceSummaryModal
            invoiceSummary={invoiceSummary}
            setLoading={setInvoiceSummaryLoading}
            payoutAcceptInvoice={payoutAcceptInvoice}
            loading={invoiceSummaryLoading}
            handleConsentCancel={handleDrawerClose}
            selectedInvoice={selectedInvoice}
          />
        )}
      </Space>
    </EbzModal>
  );
}
BulkInvoiceModal.propTypes = {
  invoiceData: PropTypes.instanceOf(Object),
  setSelectedInvoice: PropTypes.func,
  invoiceSummaryModal: PropTypes.bool,
  payoutAcceptInvoice: PropTypes.func,
  selectedInvoice: PropTypes.instanceOf(Object),
  toggleInvoiceSummary: PropTypes.func,
  columns: PropTypes.instanceOf(Object),
  bulkInvoiceModal: PropTypes.bool,
  width: PropTypes.number,
  loading: PropTypes.bool,
  toggleModal: PropTypes.func
};
BulkInvoiceModal.defaultProps = {
  invoiceData: [],
  selectedInvoice: [],
  invoiceSummaryModal: false,
  setSelectedInvoice: () => {},
  payoutAcceptInvoice: () => {},
  toggleInvoiceSummary: () => {},
  columns: [],
  bulkInvoiceModal: false,
  width: '120px',
  loading: false,
  toggleModal: () => {}
};

export default BulkInvoiceModal;
